const ls = require('local-storage');
const axios = require('axios');

export function fetchCatalogs() {
  const url = `${ls.get('gatewayAPI')}/company-service-api/company/catalogs`;
  const headers = { Authorization: `Bearer ${ls.get('authTokenCompany')}` };
  return axios({ method: 'get', url, headers });
}
